import "@fontsource/onest/400.css";
import "@fontsource/onest/500.css";
import "@fontsource/onest/600.css";
import "@fontsource/onest/700.css";
import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./app/App.vue";
import { router } from "./app/router";
import { i18n } from "./app/translates/translates";
import { setupScrollbarAutoHide } from "./lib/setup-scrollbar-auto-hide";

setupScrollbarAutoHide();

createApp(App).use(i18n).use(router).use(createPinia()).mount("#app");
